export const exception = (state) => state.exception
export const exceptions = (state) => state.exceptions
export const currentExceptions = (state) => state.currentExceptions
export const currentStates = (state) => state.currentStates
export const currentPage = (state) => state.page
export const showModal = (state) => state.showModal
export const status = (state) => state.status
export const isCreated = (state) => state.isCreated
export const isSearched = (state) => state.isSearched
